export default __webpack_public_path__ + "static/media/pic_List.b7c65d2a.svg";